/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateNotificationRequest,
  CreateNotificationSettingsRequest,
  ListNotificationsResponse,
  MarkNotificationsAsReadRequest,
  MarkNotificationsAsReadResponse,
  Notification,
  NotificationSettings,
  Problem,
  UpdateNotificationRequest,
  UpdateNotificationSettingsRequest,
} from '../models/index';
import {
    CreateNotificationRequestFromJSON,
    CreateNotificationRequestToJSON,
    CreateNotificationSettingsRequestFromJSON,
    CreateNotificationSettingsRequestToJSON,
    ListNotificationsResponseFromJSON,
    ListNotificationsResponseToJSON,
    MarkNotificationsAsReadRequestFromJSON,
    MarkNotificationsAsReadRequestToJSON,
    MarkNotificationsAsReadResponseFromJSON,
    MarkNotificationsAsReadResponseToJSON,
    NotificationFromJSON,
    NotificationToJSON,
    NotificationSettingsFromJSON,
    NotificationSettingsToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    UpdateNotificationRequestFromJSON,
    UpdateNotificationRequestToJSON,
    UpdateNotificationSettingsRequestFromJSON,
    UpdateNotificationSettingsRequestToJSON,
} from '../models/index';

export interface CreateNotificationOperationRequest {
    createNotificationRequest: CreateNotificationRequest;
}

export interface CreateNotificationSettingsOperationRequest {
    createNotificationSettingsRequest: CreateNotificationSettingsRequest;
}

export interface DeleteNotificationRequest {
    notificationId: number;
}

export interface GetNotificationRequest {
    notificationId: number;
}

export interface ListNotificationsRequest {
    companyId?: number;
    userId?: number;
    resourceType?: string;
    unreadOnly?: boolean;
    limit?: number;
    offset?: number;
}

export interface MarkNotificationsAsReadOperationRequest {
    markNotificationsAsReadRequest: MarkNotificationsAsReadRequest;
}

export interface UpdateNotificationOperationRequest {
    notificationId: number;
    updateNotificationRequest: UpdateNotificationRequest;
}

export interface UpdateNotificationSettingsOperationRequest {
    updateNotificationSettingsRequest: UpdateNotificationSettingsRequest;
}

/**
 * NotificationsApi - interface
 * 
 * @export
 * @interface NotificationsApiInterface
 */
export interface NotificationsApiInterface {
    /**
     * 
     * @summary Create a notification
     * @param {CreateNotificationRequest} createNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    createNotificationRaw(requestParameters: CreateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>>;

    /**
     * Create a notification
     */
    createNotification(requestParameters: CreateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification | null | undefined >;

    /**
     * 
     * @summary Create notification settings
     * @param {CreateNotificationSettingsRequest} createNotificationSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    createNotificationSettingsRaw(requestParameters: CreateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSettings>>;

    /**
     * Create notification settings
     */
    createNotificationSettings(requestParameters: CreateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSettings>;

    /**
     * 
     * @summary Delete a notification
     * @param {number} notificationId Notification ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    deleteNotificationRaw(requestParameters: DeleteNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a notification
     */
    deleteNotification(requestParameters: DeleteNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get a notification by ID
     * @param {number} notificationId Notification ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    getNotificationRaw(requestParameters: GetNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>>;

    /**
     * Get a notification by ID
     */
    getNotification(requestParameters: GetNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification>;

    /**
     * 
     * @summary Get notification settings for current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    getNotificationSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSettings>>;

    /**
     * Get notification settings for current user
     */
    getNotificationSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSettings>;

    /**
     * 
     * @summary List notifications
     * @param {number} [companyId] Filter by company ID
     * @param {number} [userId] Filter by user ID
     * @param {string} [resourceType] Filter by resource type
     * @param {boolean} [unreadOnly] Return only unread notifications
     * @param {number} [limit] Maximum number of notifications to return
     * @param {number} [offset] Number of notifications to skip
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    listNotificationsRaw(requestParameters: ListNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListNotificationsResponse>>;

    /**
     * List notifications
     */
    listNotifications(requestParameters: ListNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListNotificationsResponse>;

    /**
     * 
     * @summary Mark multiple notifications as read
     * @param {MarkNotificationsAsReadRequest} markNotificationsAsReadRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    markNotificationsAsReadRaw(requestParameters: MarkNotificationsAsReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkNotificationsAsReadResponse>>;

    /**
     * Mark multiple notifications as read
     */
    markNotificationsAsRead(requestParameters: MarkNotificationsAsReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkNotificationsAsReadResponse>;

    /**
     * 
     * @summary Update a notification
     * @param {number} notificationId Notification ID
     * @param {UpdateNotificationRequest} updateNotificationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    updateNotificationRaw(requestParameters: UpdateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>>;

    /**
     * Update a notification
     */
    updateNotification(requestParameters: UpdateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification>;

    /**
     * 
     * @summary Update notification settings for current user
     * @param {UpdateNotificationSettingsRequest} updateNotificationSettingsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApiInterface
     */
    updateNotificationSettingsRaw(requestParameters: UpdateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSettings>>;

    /**
     * Update notification settings for current user
     */
    updateNotificationSettings(requestParameters: UpdateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSettings>;

}

/**
 * 
 */
export class NotificationsApi extends runtime.BaseAPI implements NotificationsApiInterface {

    /**
     * Create a notification
     */
    async createNotificationRaw(requestParameters: CreateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters['createNotificationRequest'] == null) {
            throw new runtime.RequiredError(
                'createNotificationRequest',
                'Required parameter "createNotificationRequest" was null or undefined when calling createNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNotificationRequestToJSON(requestParameters['createNotificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Create a notification
     */
    async createNotification(requestParameters: CreateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification | null | undefined > {
        const response = await this.createNotificationRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 201:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Create notification settings
     */
    async createNotificationSettingsRaw(requestParameters: CreateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSettings>> {
        if (requestParameters['createNotificationSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'createNotificationSettingsRequest',
                'Required parameter "createNotificationSettingsRequest" was null or undefined when calling createNotificationSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/settings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNotificationSettingsRequestToJSON(requestParameters['createNotificationSettingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationSettingsFromJSON(jsonValue));
    }

    /**
     * Create notification settings
     */
    async createNotificationSettings(requestParameters: CreateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSettings> {
        const response = await this.createNotificationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a notification
     */
    async deleteNotificationRaw(requestParameters: DeleteNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError(
                'notificationId',
                'Required parameter "notificationId" was null or undefined when calling deleteNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/{notificationId}`.replace(`{${"notificationId"}}`, encodeURIComponent(String(requestParameters['notificationId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a notification
     */
    async deleteNotification(requestParameters: DeleteNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteNotificationRaw(requestParameters, initOverrides);
    }

    /**
     * Get a notification by ID
     */
    async getNotificationRaw(requestParameters: GetNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError(
                'notificationId',
                'Required parameter "notificationId" was null or undefined when calling getNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/{notificationId}`.replace(`{${"notificationId"}}`, encodeURIComponent(String(requestParameters['notificationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Get a notification by ID
     */
    async getNotification(requestParameters: GetNotificationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification> {
        const response = await this.getNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get notification settings for current user
     */
    async getNotificationSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSettings>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationSettingsFromJSON(jsonValue));
    }

    /**
     * Get notification settings for current user
     */
    async getNotificationSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSettings> {
        const response = await this.getNotificationSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * List notifications
     */
    async listNotificationsRaw(requestParameters: ListNotificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListNotificationsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['companyId'] != null) {
            queryParameters['companyId'] = requestParameters['companyId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['resourceType'] != null) {
            queryParameters['resourceType'] = requestParameters['resourceType'];
        }

        if (requestParameters['unreadOnly'] != null) {
            queryParameters['unreadOnly'] = requestParameters['unreadOnly'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListNotificationsResponseFromJSON(jsonValue));
    }

    /**
     * List notifications
     */
    async listNotifications(requestParameters: ListNotificationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListNotificationsResponse> {
        const response = await this.listNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mark multiple notifications as read
     */
    async markNotificationsAsReadRaw(requestParameters: MarkNotificationsAsReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MarkNotificationsAsReadResponse>> {
        if (requestParameters['markNotificationsAsReadRequest'] == null) {
            throw new runtime.RequiredError(
                'markNotificationsAsReadRequest',
                'Required parameter "markNotificationsAsReadRequest" was null or undefined when calling markNotificationsAsRead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/mark-as-read`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MarkNotificationsAsReadRequestToJSON(requestParameters['markNotificationsAsReadRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MarkNotificationsAsReadResponseFromJSON(jsonValue));
    }

    /**
     * Mark multiple notifications as read
     */
    async markNotificationsAsRead(requestParameters: MarkNotificationsAsReadOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MarkNotificationsAsReadResponse> {
        const response = await this.markNotificationsAsReadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a notification
     */
    async updateNotificationRaw(requestParameters: UpdateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Notification>> {
        if (requestParameters['notificationId'] == null) {
            throw new runtime.RequiredError(
                'notificationId',
                'Required parameter "notificationId" was null or undefined when calling updateNotification().'
            );
        }

        if (requestParameters['updateNotificationRequest'] == null) {
            throw new runtime.RequiredError(
                'updateNotificationRequest',
                'Required parameter "updateNotificationRequest" was null or undefined when calling updateNotification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/{notificationId}`.replace(`{${"notificationId"}}`, encodeURIComponent(String(requestParameters['notificationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNotificationRequestToJSON(requestParameters['updateNotificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationFromJSON(jsonValue));
    }

    /**
     * Update a notification
     */
    async updateNotification(requestParameters: UpdateNotificationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Notification> {
        const response = await this.updateNotificationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update notification settings for current user
     */
    async updateNotificationSettingsRaw(requestParameters: UpdateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NotificationSettings>> {
        if (requestParameters['updateNotificationSettingsRequest'] == null) {
            throw new runtime.RequiredError(
                'updateNotificationSettingsRequest',
                'Required parameter "updateNotificationSettingsRequest" was null or undefined when calling updateNotificationSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/notifications/settings`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateNotificationSettingsRequestToJSON(requestParameters['updateNotificationSettingsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NotificationSettingsFromJSON(jsonValue));
    }

    /**
     * Update notification settings for current user
     */
    async updateNotificationSettings(requestParameters: UpdateNotificationSettingsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NotificationSettings> {
        const response = await this.updateNotificationSettingsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
